//@ts-check
import React, { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { bool, func, number, string } from 'prop-types';

import { track } from '@gumtree/shared/src/actions';
import { Button, RadioButton, TextArea } from '@gumtree/ui-library';
import sendSellerReport from './send-seller-report';
import { ToggleContent, ErrorMessage } from './index.style';
import { setSendReportSuccess } from '../../reducers/seller-actions';

import { ButtonGroup } from '../../app.style';
import { VIP_SUPPORT } from '../support-links';

const reportOptions = [
    {
        label: 'This is illegal/fraudulent',
        name: 'attributes[report_listing]',
        id: 'two',
        value: '2',
    },
    {
        label: 'This ad is spam',
        name: 'attributes[report_listing]',
        id: 'six',
        value: '6',
    },
    {
        label: 'This ad is a duplicate',
        name: 'attributes[report_listing]',
        id: 'three',
        value: '3',
    },
    {
        label: 'This ad is in the wrong category',
        name: 'attributes[report_listing]',
        id: 'four',
        value: '4',
    },
    {
        label: 'The ad goes against ',
        name: 'attributes[report_listing]',
        linkDataQ: 'posting-rules',
        labelLink: 'https://help.gumtree.com/knowledgeProduct?c=Posting_rules',
        labelLinkText: 'posting rules',
        id: 'one',
        value: '1',
    },
];

const ReportSellerBlock = ({ csrfToken, isOpen, stateClick, id }) => {
    const dispatch = useDispatch();

    const [reportNumber, setReportNumber] = useState();
    const [reportText, setReportText] = useState('');
    const [isSuccess, setSuccess] = useState(false);
    const [errorText, setErrorText] = useState('');

    const updateRadio = (e) => {
        setReportNumber(e.currentTarget.value);
    };

    const updateText = (e) => {
        setReportText(e.currentTarget.value);
    };

    const sendReport = async (e, reportNumber, reportText, adId) => {
        const selectedReason = reportOptions.find((option) => option.value === reportNumber);
        const result = await sendSellerReport(
            e,
            reportNumber,
            reportText,
            adId,
            csrfToken,
            selectedReason
        );

        if (result.success) {
            dispatch(setSendReportSuccess(true));
            setSuccess(true);
        }
    };

    const handleSendReport = (e) => {
        if (reportNumber === undefined) {
            setErrorText('Please select an option');
            track('ReportAdFail');
        } else if (reportNumber === '1' && reportText.length < 1) {
            setErrorText('Please provide more information');
            track('ReportAdFail');
        } else {
            setErrorText('');
            sendReport(e, reportNumber, reportText, id);
        }
    };

    return (
        <ToggleContent data-q="report-seller-block" isOpen={isOpen}>
            {!isSuccess ? (
                <Fragment>
                    {reportOptions.map((optionProps) => (
                        <RadioButton key={optionProps.id} {...optionProps} onChange={updateRadio} />
                    ))}
                    {errorText && (
                        <ul>
                            <ErrorMessage data-q="report-seller-error">{errorText}</ErrorMessage>
                        </ul>
                    )}
                    <TextArea placeHolder="Please provide more information" onChange={updateText} />
                    <ButtonGroup>
                        <Button
                            display="secondary"
                            className="close-reporter"
                            onClick={() => {
                                stateClick();
                                track('ReportAdCancel');
                            }}
                            label="Cancel"
                        />
                        <Button
                            display="primary"
                            label="Send report"
                            onClick={handleSendReport}
                            data-q="send-report-button"
                        />
                    </ButtonGroup>
                </Fragment>
            ) : (
                <div className="feedback-success-container">
                    <h4>Thank you</h4>
                    <p>Your feedback is valuable to us as it helps us improve Gumtree.</p>
                    <p>We will review this ad as soon as possible.</p>
                    <p>
                        We are not able to respond back to you, so if the ad remains on site after
                        12 hours then we have chosen to leave the ad live.
                    </p>
                    <p>
                        If you are a victim of fraud click{' '}
                        <a href={VIP_SUPPORT.FRAUD_SUPPORT}>here</a>
                    </p>
                    <p>The Gumtree Community Team</p>
                    <Button
                        display="primary"
                        className="close-reporter"
                        label="Close"
                        onClick={stateClick}
                    />
                </div>
            )}
        </ToggleContent>
    );
};

ReportSellerBlock.propTypes = {
    csrfToken: string.isRequired,
    id: number.isRequired,
    isOpen: bool.isRequired,
    stateClick: func.isRequired,
};

export default ReportSellerBlock;
